import { oc } from 'ts-optchain';

import { StoreType } from '@tock/shared/utils/connect';
import { createDeepEqualSelector } from 'utils/service/selectorUtils';

const numPendingMessagesSelector = createDeepEqualSelector(
  (state: StoreType) => oc(state).service.app.communicator(),
  calcNumPendingMessagesFromCommunicator
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function calcNumPendingMessagesFromCommunicator(communicator?: any) {
  if (!communicator) {
    return 0;
  }
  return (communicator.messagePendingResponse ? 1 : 0) + communicator.messagesToSend.length;
}

export default numPendingMessagesSelector;
